<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{ isEditMode
                ? (translate?.general.buttons.edit.singular + ' ' + translate?.setup.users.shifts.label.singular + ' ' + translate?.setup.users.shifts.sections.sec1.singular)
                : (translate?.general.buttons.assign.singular + ' ' + translate?.setup.users.shifts.label.singular) }}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body p-0">
         <section class="howto-card m-3">
            <h3 class="howto-title">
                <i class="fa-regular fa-lightbulb-on howto-icon"></i>
                 {{translate?.general.messages.howToUse}}
            </h3>

            <p class="howto-subtitle">
               {{translate?.setup.users.shifts.messages.howToUseAssignSubtitle}}
            </p>

            <p class="howto-quick-heading"> {{translate?.general.messages.quickSteps}}</p>
            <ul class="howto-list">
                <li>a. {{translate?.setup.users.shifts.messages.groupAssignmentDesc}}</li>
                <li>b. {{translate?.setup.users.shifts.messages.individualPermanentDesc}} {{translate?.setup.users.shifts.label.singular}}
                    {{translate?.setup.users.shifts.sections.sec0.singular}} {{translate?.setup.users.shifts.messages.individualPermanentAssignsTo}}
                    {{translate?.setup.users.users.label.singular | lowercase}} {{translate?.setup.users.shifts.messages.individualPermanentNoEndDate}}</li>
                <li>c. {{translate?.setup.users.shifts.messages.individualOverrideDesc}}{{translate?.setup.users.shifts.label.singular}}
                    {{translate?.setup.users.shifts.sections.sec0.singular}} {{translate?.setup.users.shifts.messages.individualOverrideAssignsTo}}
                    {{translate?.setup.users.users.label.singular | lowercase}} {{translate?.setup.users.shifts.messages.individualOverrideDateRange}}</li>
            </ul>

            <p class="howto-note">{{translate?.setup.users.shifts.messages.groupPrecedenceNote}} {{translate?.setup.users.groups.label.singular}}
                {{translate?.setup.users.shifts.messages.groupPrecedenceTakesPrecedence}} {{translate?.setup.users.users.label.singular | lowercase}}
                {{translate?.setup.users.shifts.messages.groupPrecedenceBelongsTo}} {{translate?.setup.users.groups.label.singular | lowercase}}
                {{translate?.setup.users.shifts.messages.groupPrecedenceWithAssignedShift}} {{translate?.setup.users.groups.label.singular | lowercase}}
                {{translate?.setup.users.shifts.messages.groupPrecedenceShiftOverride}} {{translate?.setup.users.users.label.singular | lowercase}}.</p>
        </section>
        <p-tabView class="px-0 tabs-flx-modal" [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">
            <p-tabPanel [header]="translate?.general.buttons.assign.singular + ' ' + translate?.general.messages.toLower + ' ' + translate?.setup.users.users.label.singular" *ngIf="isUsersMode">

                <div class="flx-modal__body bg-white">
                    <div class="status-field">
                        <label class="field-label mandatory">{{translate?.setup.users.shifts.fields.targetUser.singular}}</label>
                        <div class="field-row field-row--auto">
                            <p-dropdown
                                [options]="userOptions"
                                [(ngModel)]="selectedUser"
                                optionLabel="fullName"
                                optionValue="id"
                                [filter]="true"
                                filterBy="fullName"
                                [placeholder]="translate?.general?.buttons?.select2?.singular +' ' + translate?.setup.users.users.label.singular"
                                [disabled]="isUserLocked"
                                appendTo="body">
                            </p-dropdown>
                        </div>
                        <div class="p-error text-10 mt-1" *ngIf="submitTouched && isUsersMode && !selectedUser">
                            {{ translate?.general.validationFE.requiredField }}
                        </div>
                    </div>
                    <div class="status-field">
                        <label class="field-label mandatory">{{translate?.setup.users.shifts.label.singular}} {{translate?.setup.users.shifts.sections.sec0.singular}}</label>
                        <div class="field-row field-row--auto">
                            <p-dropdown
                                [options]="shiftTypeOptions"
                                [(ngModel)]="selectedUserShiftType"
                                optionLabel="name"
                                optionValue="id"
                                [filter]="true"
                                filterBy="name,code"
                                [placeholder]=" translate?.general?.buttons?.select2?.singular + ' ' + translate?.setup.users.shifts.label.singular + ' ' + translate?.setup.users.shifts.sections.sec0.singular "
                                [disabled]="isShiftTypeLocked"
                                appendTo="body">
                            </p-dropdown>
                        </div>
                        <div class="p-error text-10 mt-1" *ngIf="submitTouched && isUsersMode && !selectedUserShiftType">
                            {{ translate?.general.validationFE.requiredField }}
                        </div>
                    </div>
                    <div class="status-field">
                        <div class="field-row--auto_range mp-row">
                            <div class="status-field">
                                <span class="field-label mandatory">{{translate?.setup.users.shifts.fields.effectiveStartDate.singular}}</span>
                                 <p-calendar
                                    [(ngModel)]="userStartDate"
                                    [placeholder]="translate?.task.fields.selectDate.singular"
                                    [showIcon]="true"
                                    appendTo="body"
                                    styleClass="cal-btn"
                                    dateFormat="dd/mm/yy">
                                 </p-calendar>
                                 <div class="p-error text-10 mt-1" *ngIf="submitTouched && isUsersMode && !userStartDate">
                                    {{ translate?.general.validationFE.requiredField }}
                                 </div>
                            </div>
                            <span class="divider"><i class="fa-solid fa-minus"></i></span>
                            <div class="status-field">
                                <span class="field-label">{{translate?.setup.users.shifts.fields.effectiveEndDate.singular}}</span>
                                 <p-calendar
                                    [(ngModel)]="userEndDate"
                                    [placeholder]="translate?.task.fields.selectDate.singular"
                                    [showIcon]="true"
                                    appendTo="body"
                                    styleClass="cal-btn"
                                    dateFormat="dd/mm/yy"
                                    [minDate]="userStartDate || undefined">
                                 </p-calendar>
                                 <div class="p-error text-10 mt-1" *ngIf="submitTouched && isUsersMode && isUserDateRangeInvalid">
                                    {{translate?.setup.users.shifts.validationFE.endDateAfterStartDate}}
                                 </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

            </p-tabPanel>

            <p-tabPanel [header]="translate?.general.buttons.assign.singular+ ' ' + translate?.general.messages.toLower + ' ' + translate?.setup.users.groups.label.singular" *ngIf="isGroupsMode">
                <div class="flx-modal__body bg-white">
                    <div class="status-field">
                        <label class="field-label mandatory">{{translate?.setup.users.shifts.fields.targetGroup.singular}}</label>
                        <div class="field-row field-row--auto">
                            <p-dropdown
                                [options]="groupOptions"
                                [(ngModel)]="selectedGroup"
                                optionLabel="name"
                                optionValue="id"
                                [filter]="true"
                                filterBy="name"
                                [placeholder]="translate?.general?.buttons?.select2?.singular +' ' + translate?.setup.users.groups.label.singular"
                                [disabled]="isGroupLocked"
                                appendTo="body">
                            </p-dropdown>
                        </div>
                        <div class="p-error text-10 mt-1" *ngIf="submitTouched && isGroupsMode && !selectedGroup">
                            {{ translate?.general.validationFE.requiredField }}
                        </div>
                    </div>
                    <div class="status-field">
                        <label class="field-label mandatory">{{translate?.setup.users.shifts.label.singular}} {{translate?.setup.users.shifts.sections.sec0.singular}}</label>
                        <div class="field-row field-row--auto">
                            <p-dropdown
                                [options]="shiftTypeOptions"
                                [(ngModel)]="selectedGroupShiftType"
                                optionLabel="name"
                                optionValue="id"
                                [filter]="true"
                                filterBy="name,code"
                                [placeholder]="translate?.general?.buttons?.select2?.singular + ' ' + translate?.setup.users.shifts.label.singular + ' ' + translate?.setup.users.shifts.sections.sec0.singular"
                                [disabled]="isShiftTypeLocked"
                                appendTo="body">
                            </p-dropdown>
                        </div>
                        <div class="p-error text-10 mt-1" *ngIf="submitTouched && isGroupsMode && !selectedGroupShiftType">
                            {{ translate?.general.validationFE.requiredField }}
                        </div>
                    </div>
                    <div class="status-field">
                        <div class="field-row--auto_range mp-row">
                            <div class="status-field">
                                <span class="field-label mandatory">{{translate?.setup.users.shifts.fields.effectiveStartDate.singular}}</span>
                                 <p-calendar
                                    [(ngModel)]="groupStartDate"
                                    [placeholder]="translate?.task.fields.selectDate.singular"
                                    [showIcon]="true"
                                    appendTo="body"
                                    styleClass="cal-btn"
                                    dateFormat="dd/mm/yy">
                                 </p-calendar>
                                 <div class="p-error text-10 mt-1" *ngIf="submitTouched && isGroupsMode && !groupStartDate">
                                    {{ translate?.general.validationFE.requiredField }}
                                 </div>
                            </div>
                            <span class="divider"><i class="fa-solid fa-minus"></i></span>
                            <div class="status-field">
                                <span class="field-label">{{translate?.setup.users.shifts.fields.effectiveEndDate.singular}}</span>
                                 <p-calendar
                                    [(ngModel)]="groupEndDate"
                                    [placeholder]="translate?.task.fields.selectDate.singular"
                                    [showIcon]="true"
                                    appendTo="body"
                                    styleClass="cal-btn"
                                    dateFormat="dd/mm/yy"
                                    [minDate]="groupStartDate || undefined">
                                 </p-calendar>
                                 <div class="p-error text-10 mt-1" *ngIf="submitTouched && isGroupsMode && isGroupDateRangeInvalid">
                                    {{translate?.setup.users.shifts.validationFE.endDateAfterStartDate}}
                                 </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

            </p-tabPanel>
        </p-tabView>
    </div>
    <div class="flx-modal__footer">
        <button class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" [label]="translate?.general.buttons.save.singular" styleClass="h-32" (onClick)="onSave()"></p-button>
    </div>
</div>
